import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NewsStream } from '@ifeng-fe/news-stream';
import Chip from 'Chip';
import '@ifeng-fe/news-stream/lib/NewsStream/style/news-stream-global.css';
import styles from './index.css';
import StaticEdit from '../../staticEdit';

class Slide extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { newsStreamRecommend, newsStream, viewMore, staticCenterData } = this.props.content;

        return (
            <div className={styles.slide}>

                <Chip id="289144" type="recommend" title="新疆频道-资讯流推荐位" groupName="main左侧数据" content={newsStreamRecommend}>
                    <div className={styles.globalContent}>
                        <div className={styles.globalItem}>
                            {newsStreamRecommend.slice(0, 6).map((item, index) => {
                                return (
                                    <a
                                        key={index}
                                        className={index === 0 ? styles.globalBoldText : styles.globalThinText}
                                        href={item.url}
                                        target="_blank">
                                        {item.title}
                                    </a>
                                );
                            })}
                        </div>
                    
                    </div>
                </Chip>

                <NewsStream content={newsStream} isEnd={true} isDisplayLoadingMore={false} />
                
                <Chip id="261103" type="struct" title="查看更多" groupName="main左侧数据">
                    <div className={styles.viewMore}>
                        <a href={viewMore.url} target="_blank" className={styles.viewMoreLink}>
                            点击查看更多
                        </a>
                    </div>
                </Chip>
            
                 <Chip id="223309" type="static" title="资讯流下方－静态碎片" groupName="main左侧数据" content={staticCenterData} >
                        <StaticEdit />
                </Chip>
            </div>
        );
    }
}

export default Slide;
